import { render } from "./Invest.vue?vue&type=template&id=11c4d047"
import script from "./Invest.vue?vue&type=script&lang=js"
export * from "./Invest.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__